import FootballService from "../../services/football-service";
import FlagFootballService from "../../services/flag-football-service";
import TeamService from "../../services/team-service";
import GameService from "../../services/game-service";
import PlayerService from "../../services/player-service";
import StreamService from "../../services/stream-service";
import ContextService from "../../services/context-service";
import GamedayApiService from "../../services/gameday-api-service";
import StretchLiveApiService from "../../services/stretchlive-api-service";
import SeasonService from "../../services/season-service";
import EventService from "../../services/event-service";
import SportService from "../../services/sport-service";
import ImportService from "../../services/import-service";
import StorageService from "../../services/storage-service";
import ValidationService from "../../services/validation-service";
import MatchService from "../../services/match-service";
import SecurityService from "../../services/security-service";
import HomeService from "../../services/home-service";
import ApplicationService from "../../services/application-service";
import TennisService from "../../services/tennis-service";
import SportResolverService from "../../services/sport-resolver-service";
import FootballSyncService from "../../services/sync/football-sync-service";
import TennisSyncService from "../../services/sync/tennis-sync-service";
import SyncService from "../../services/sync/sync-service";
import DriveService from "../../services/drive-service";
import SyncServiceFactory from "../../services/sync/sync-service-factory";
import SeasonSettingsProvider from "../../services/providers/season-settings-provider";
import GamedaySeasonSettingsProvider from "../../services/providers/gameday-season-settings-provider";

export default {
    ContextService,
    DriveService,
    GameService,
    GamedayApiService,
    StretchLiveApiService,
    FootballService,
    FlagFootballService,
    PlayerService,
    StreamService,
    TeamService,
    SeasonService,
    EventService,
    SportService,
    ImportService,
    StorageService,
    ValidationService,
    MatchService,
    SecurityService,
    HomeService,
    ApplicationService,
    TennisService,
    SportResolverService,
    FootballSyncService,
    TennisSyncService,
    SyncService,
    SyncServiceFactory,
    SeasonSettingsProvider,
    GamedaySeasonSettingsProvider
};
